import React, { useEffect, useState } from "react";
import Header from "../../components/InternationalAcademy/Header";
import Logo from "../../assets/images/InternationalAcademy/logo.png";
import { useLocation } from 'react-router-dom'

const OurSchool = () => {
  const location = useLocation();
  const [currentSection, setSection] = useState("all");
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      setSection(hash)
    } else {
      setSection("all")
    }
  }, [location]);
  return (
    <div>
      <Header />
      <div className="my-24 flex items-center flex-col gap-3">
        <img src={Logo} className="w-60" alt="" />
        <h2 className="text-xl md:text-3xl">International Academy Myanmar</h2>
        <div className="lg:w-3/4 px-5 mt-10 flex flex-col gap-5">
          {(currentSection === "all" || currentSection === "#mission") && <div>
            <h2 className="font-semibold text-lg py-2">Mission</h2>
            <p>
              Our mission at International Academy Myanmar is to provide a
              world-class education that empowers students to excel
              academically, socially, and personally. We strive to foster an
              inclusive learning environment that promotes critical thinking,
              creativity, and cultural understanding, enabling our students to
              contribute positively to their communities and the world.
            </p>
          </div>
          }
          {(currentSection === "all" || currentSection === "#vision") && <div>
            <h2 className="font-semibold text-lg py-2">Vision</h2>
            <p>
              Our vision is to be a beacon of educational excellence, recognized
              internationally for producing graduates who exhibit leadership,
              empathy, and a strong sense of global responsibility. We aim to
              create a learning community that embraces diversity, innovation,
              and collaboration, preparing students to address the challenges
              and opportunities of the 21st century.
            </p>
          </div>
          }

          {(currentSection === "all" || currentSection === "#founder") &&
           <div>  <h2 className="font-semibold text-lg py-2">Founder</h2>
            <p>
              International Academy Myanmar was founded by Phyu Sin Tun Lin, an
              accomplished educator and visionary leader. With a degree from the
              prestigious University of Manchester, Phyu Sin Tun Lin brings a
              wealth of experience and a deep passion for education. Her
              commitment to providing quality education and fostering a
              nurturing environment for students has been instrumental in
              shaping the academy's core values and educational philosophy.
            </p>
          </div>
          }
          {(currentSection === "all" || currentSection === "#education") && <div>
            <h2 className="font-semibold text-lg py-2">Educational Philosophy</h2>
            <p>
              At International Academy Myanmar, we believe in a learner-centered
              approach that emphasizes active engagement, critical thinking, and
              experiential learning. Our curriculum is designed to be rigorous
              and globally relevant, integrating both local and international
              perspectives. We aim to cultivate lifelong learners who are
              adaptable, open-minded, and equipped to succeed in a rapidly
              evolving world.
            </p>
          </div>
          }
          {(currentSection === "all" || currentSection === "#academic") && <section>
            <h2 className="font-semibold text-lg py-2">Academic Programs</h2>
            <p>
              We offer a comprehensive range of academic programs, from early
              childhood education to high school, that are designed to meet the
              diverse needs and aspirations of our students. Our curriculum
              covers a broad spectrum of subjects, including mathematics,
              sciences, languages, humanities, and the arts, ensuring a
              well-rounded education that prepares students for a wide array of
              career paths and higher education opportunities.
            </p>
          </section>
          }

          {(currentSection === "all" || currentSection === "#campus") &&
            <section>
              <h2 className="font-semibold text-lg py-2">Campus and Facilities</h2>
              <p>
                Our state-of-the-art campus provides a conducive environment for
                learning and growth. Equipped with modern classrooms,
                well-equipped laboratories, libraries, sports facilities, and
                dedicated spaces for artistic expression, our campus promotes
                holistic development and offers students a well-rounded
                educational experience.
              </p>
            </section>
          }
          {(currentSection === "all" || currentSection === "#global") &&
            <section>
              <h2 className="font-semibold text-lg py-2">Global Exposure</h2>
              <p>
                International Academy Myanmar places a strong emphasis on global
                exposure and cross-cultural understanding. Through partnerships
                with international schools, exchange programs, and collaborative
                projects, students have the opportunity to connect with peers from
                different parts of the world, broadening their perspectives and
                enhancing their intercultural competence.
              </p>
            </section>
          }
          {(currentSection === "all" || currentSection === "#community") &&
            <section>
              <h2 className="font-semibold text-lg py-2">Community Engagement</h2>
              <p>
                We are committed to fostering a strong sense of community among
                students, parents, teachers, and staff. Regular events, workshops,
                and seminars encourage active participation and collaboration,
                creating a supportive network that enhances the overall
                educational experience.
              </p>
            </section>
          }
          {(currentSection === "all" || currentSection === "#core") &&
            <div>
              <section>
                <h2 className="font-semibold text-lg py-2">Core Values</h2>
                <ul>
                  <li>
                    <strong>Excellence:</strong> Striving for the highest standards
                    in education and personal growth.
                  </li>
                  <li>
                    <strong>Integrity:</strong> Upholding honesty, respect, and
                    ethical behavior in all interactions.
                  </li>
                  <li>
                    <strong>Innovation:</strong> Embracing creativity and
                    adaptability to drive continuous improvement.
                  </li>
                  <li>
                    <strong>Diversity:</strong> Celebrating and respecting the
                    uniqueness of individuals and cultures.
                  </li>
                  <li>
                    <strong>Empowerment:</strong> Equipping students with the skills
                    and confidence to shape their futures.
                  </li>
                </ul>
              </section>


              <section>
                <p>
                  At International Academy Myanmar, we are dedicated to shaping the
                  leaders and thinkers of tomorrow, instilling in them the values
                  and knowledge necessary to make a positive impact on the global
                  stage. We invite students, parents, and partners to join us in
                  this transformative journey of education and growth.
                </p>
              </section>
              <section>
                <h2 className="font-semibold">Educational Philosophy</h2>
                <p>
                  We believe that children will succeed through experiencing quality
                  in:
                </p>
                <ul>
                  <li>
                    A broad, balanced, and challenging curriculum, sensitive to the
                    needs of the individual.
                  </li>
                  <li>
                    A secure, respectful, caring, and stimulating learning
                    environment.
                  </li>
                  <li>
                    An enriching program of extra-curricular activities and visits.
                  </li>
                  <li>
                    A rich, varied, and up-to-date range of learning resources.
                  </li>
                  <li>
                    Innovative teaching and an investigative approach to learning.
                  </li>
                  <li>
                    An ethos of support, encouragement, and challenge to succeed.
                  </li>
                  <li>
                    Learning partnerships between school, home, and the wider
                    community.
                  </li>
                </ul>
                <p>
                  We demonstrate our commitment to working as a learning community
                  by:
                </p>
                <ul>
                  <li>
                    Respecting the individual but working collaboratively towards
                    common goals with shared learning outcomes.
                  </li>
                  <li>
                    Constantly monitoring and evaluating our progress – endeavoring
                    to become a self-evaluating school.
                  </li>
                  <li>Striving for continuous improvement in all that we do.</li>
                </ul>
                <p>Our broad aims are:</p>
                <ul>
                  <li>
                    To arouse children’s curiosity and foster a desire to learn
                    about the world in which they live.
                  </li>
                  <li>
                    For children to acquire knowledge, skills, and practical
                    abilities and the will to use them.
                  </li>
                </ul>
              </section>
              <section>
                <h2 className="font-semibold">
                  Specific Objectives for Our Children
                </h2>
                <ul>
                  <li>
                    To read fluently and accurately, with understanding, feeling,
                    and discrimination.
                  </li>
                  <li>
                    To develop a legible style of handwriting and satisfactory
                    standards of spelling, syntax, punctuation, and usage.
                  </li>
                  <li>
                    To communicate clearly and confidently in speech and writing, in
                    ways appropriate for various occasions and purposes.
                  </li>
                  <li>To listen attentively and with understanding.</li>
                  <li>
                    To learn how to acquire information from various sources and to
                    record information and findings in various ways.
                  </li>
                  <li>To apply computational skills with speed and accuracy.</li>
                  <li>
                    To understand the applications of mathematical ideas in various
                    situations in the home, classroom, school, and the local area.
                  </li>
                  <li>
                    To observe living and inanimate things and to recognize
                    characteristics such as pattern and order.
                  </li>
                  <li>To master basic scientific and technological ideas.</li>
                  <li>
                    To investigate solutions and interpret evidence, to analyze and
                    to solve problems.
                  </li>
                  <li>
                    To develop awareness of self and sensitivity to others, acquire
                    a set of moral values and the confidence to make and to hold
                    moral judgments, and to develop habits of self-discipline and
                    acceptable behavior.
                  </li>
                  <li>
                    To be aware of the geographical, historical, and social aspects
                    of the local environment and the national heritage, and to be
                    aware of other times and places.
                  </li>
                  <li>
                    To acquire sufficient control of self or tools, equipment, and
                    instruments to be able to use music, drama, and several forms of
                    arts and crafts as means of expression.
                  </li>
                  <li>
                    To develop agility and physical coordination, confidence in and
                    through physical activity, and the ability to express feeling
                    through movement.
                  </li>
                  <li>
                    To foster an interest and gain confidence in using Information
                    and Communication Technology.
                  </li>
                  <li>
                    To include any other subjects which may form part of a future
                    curriculum.
                  </li>
                </ul>
              </section>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default OurSchool;
